import { render } from "./SelectSize.vue?vue&type=template&id=56c98d2e&scoped=true"
import script from "./SelectSize.vue?vue&type=script&lang=js"
export * from "./SelectSize.vue?vue&type=script&lang=js"

import "./SelectSize.vue?vue&type=style&index=0&id=56c98d2e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c98d2e"]])

export default __exports__